import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Import components
import Login from './Components/Pages/Login';
import ResetPassword from './Components/Pages/ResetPassword';
import SetNewPassword from './Components/Pages/SetNewPassword';
import Dashboard from './Components/Pages/Dashboard';
import JobDetails from './Components/Pages/JobDetails';
import CandidateDetails from './Components/Pages/CandidateDetails';
import EvaluationDetails from './Components/EvaluationComponents/EvaluationDetails';
import Jobs from './Components/Pages/Jobs';
import Talent from './Components/Pages/Talent';
import TalentDetails from './Components/Pages/TalentDetails';
import PrintableEvaluationReport from './Components/CandidateComponents/PrintableEvaluationReport';
import PrintableJobProfileFit from './Components/CandidateComponents/PrintableJobProfileFit';
import PrintableTalentProfileAssessment from './Components/TalentComponents/PrintableTalentProfileAssessment';
import PublicTalentProfileAssessment from './Components/Pages/PublicTalentProfileAssessment';
import CandidateReport_Public from './Components/ReportComponents/CandidateReport_Public';
import TalentReport_Public from './Components/ReportComponents/TalentReport_Public';
import Documentation from './Components/Pages/Documentation';
import Evaluations from './Components/Pages/Evaluations';
import Settings from './Components/Pages/Settings';
import Prompts from './Components/Pages/Prompts';
import Library from './Components/Pages/Library';
import ProtectedRoute from './Components/Utils/ProtectedRoute';
import { SessionProvider } from './Components/Utils/SessionContext';

function App() {
  return (
    <SessionProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/passwordreset" element={<ResetPassword />} />
          <Route path="/setnewpassword" element={<SetNewPassword />} />
          <Route path="/ptpa" element={<PublicTalentProfileAssessment />} />
          <Route path="/candidate/:candidate_id/:password_uuid" element={<CandidateReport_Public />} />
          <Route path="/talent/:talent_id/:password_uuid" element={<TalentReport_Public />} />
          <Route path="/documentation" element={<Documentation />} />
          
          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/talent" element={<Talent />} />
            <Route path="/evaluations" element={<Evaluations />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/prompts" element={<Prompts />} />
            <Route path="/library" element={<Library />} />
            <Route path="/job-details" element={<JobDetails />} />
            <Route path="/candidate-details" element={<CandidateDetails />} />
            <Route path="/evaluation-details" element={<EvaluationDetails />} />
            <Route path="/talentdetails" element={<TalentDetails />} />
            <Route path="/printable-evaluation-report" element={<PrintableEvaluationReport />} />
            <Route path="/printable-job-profile-fit" element={<PrintableJobProfileFit />} />
            <Route path="/printable-talent-profile-assessment" element={<PrintableTalentProfileAssessment />} />
            {/* Add more protected routes here */}
          </Route>
          
          {/* Redirect to login by default */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        
        {/* Toast notifications */}
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 5000,
            style: {
              background: '#363636',
              color: '#fff',
              fontSize: '14px',
            },
            success: {
              duration: 5000,
              style: {
                background: '#10B981',
                color: '#fff',
                fontSize: '14px',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#EF4444',
                color: '#fff',
                fontSize: '14px',
              },
            },
          }}
        />
      </Router>
    </SessionProvider>
  );
}

export default App;
